import { useAuthStore } from '@/store/authStore'
import { TourProvider } from './TourProvider'
import { dashboardTourSteps } from './TourSteps'

const DASHBOARD_TOUR_STORAGE_KEY = 'vvsi-tour-seen'

/** Dashboard's configuration of the reusable tour engine — first-login guided walkthrough.
 * Scoped per logged-in user (not just per browser), so a different account on the same
 * browser always sees the welcome prompt again, even if a previous user already completed
 * or skipped it. */
export function DashboardTour() {
  const userId = useAuthStore((s) => s.user?.userId)
  const storageKey = userId != null ? `${DASHBOARD_TOUR_STORAGE_KEY}:${userId}` : DASHBOARD_TOUR_STORAGE_KEY

  return <TourProvider steps={dashboardTourSteps} storageKey={storageKey} />
}
